import {SelectInside} from '../../models/redux/selectInside'
import {Graphic} from '../../models/toolbox/graphic'

export type ToolboxTabPanel =
  | 'Graphics'
  | 'PhotoUpload'
  | 'Edit'
  | 'AddCaption'
  | 'PixaBay'
  | null

export interface ToolboxStore {
  activeTabPanel: ToolboxTabPanel
  selectForMasked: SelectInside | undefined
  pixaBayKeyword: string
  graphics: Graphic[]
  graphicCategories: {
    text: string
  }[]
}

export const initialToolboxStore: ToolboxStore = {
  activeTabPanel: null,
  selectForMasked: undefined,
  pixaBayKeyword: '',
  graphics: [],
  graphicCategories: [],
}
